'use client';

import { useTranslations } from 'next-intl';
import { SectionWrapper } from '@/components/ui/section-wrapper';
import { Typography } from '@/components/ui/typography';
import { HandHeart, Gift, TrendingUp } from 'lucide-react';

interface Plan {
  name: string;
}

interface HowItWorksSectionProps {
  plan: Plan;
}

export function HowItWorksSection({ plan }: HowItWorksSectionProps) {
  const t = useTranslations('planDetails.helpPlan.howItWorks');

  return (
    <SectionWrapper variant="default" padding="md" className="relative">
      <div className="container">
        <div className="text-center mb-12">
          <Typography variant="h2" className="mb-4">
            {t('title')}
          </Typography>
          <Typography variant="p" className="text-lg text-gray-600 dark:text-gray-400 max-w-4xl mx-auto">
            {t('description')}
          </Typography>
        </div>

        <div className="max-w-4xl mx-auto space-y-6">
          <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 border-2 border-primary-200 dark:border-primary-800">
            <Typography variant="p" className="text-gray-700 dark:text-gray-300 leading-relaxed">
              {t('paragraph1')}
            </Typography>
          </div>
          <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 border-2 border-blue-200 dark:border-blue-800">
            <Typography variant="p" className="text-gray-700 dark:text-gray-300 leading-relaxed">
              {t('paragraph2')}
            </Typography>
          </div>
          <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 border-2 border-blue-200 dark:border-blue-800">
            <Typography variant="p" className="text-gray-700 dark:text-gray-300 leading-relaxed">
              {t('paragraph3')}
            </Typography>
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
}

